export class BookingsService {
    static getColour(booking) {
        let price = parseFloat(booking.price);
        price = price * 100;
        const vat = price * 0.20;
        let total = price + vat;
        total = Math.floor(total);
        let charged = Number(booking.totalCharged);
        charged = charged * 100;
        charged = Math.ceil(charged);

        if (booking.isRepeat) {
            return "#808080";
        }

        if (booking.isProvisional) {
            return '#c3406b';
        }

        if (!price) {
            return "#027fb8";
        }

        if (booking.parentBookingId) {
            return '#673AB7';
        }

        if (booking.isGiftVoucher) {
            return '#a70ac7';
        }

        if (charged === 0) {
            return '#EF5350';
        } else if (charged >= total) {
            if (booking.primaryTrackingId || booking.parentBookingId) {
                return '#673AB7';
            } else {
                return '#66BB6A';
            }
        } else if (charged < total) {
            return '#F9A825';
        }
    }
}
